class MatchBox {

  constructor() {


      if (!this.setVars())
      return

      this.setEvents()

  }

  setVars() {

    this.section = document.querySelector('.matchBox')

    if (!this.section)
      return

    this.items    = this.section.querySelectorAll('.matchBox__infoItem')
    this.prev     = this.section.querySelector('.matchBox__infoPrev')
    this.next     = this.section.querySelector('.matchBox__infoNext')
    this.current  = 0
    this.buttons  = this.section.querySelectorAll('.matchBox__teamButton')
    this.percents = this.section.querySelectorAll('.matchBox__teamPercent')

    return true

  }

  setEvents() {

    if (this.prev)
      this.prev.addEventListener('click', () => { this.prevItem() })

    if (this.next)
      this.next.addEventListener('click', () => { this.nextItem() })

    if (this.buttons.length) {

      this.buttons.each((item, index) => {

        item.addEventListener('click', (e) => {

          e.preventDefault()
          this.pollVote(index)

        })

      })

    }

  }

  prevItem() {

    this.current--

    if (this.current < 0)
      this.current = (this.items.length - 1)

    this.setItem(this.current)

  }

  nextItem() {

    this.current++

    if (this.current >= (this.items.length - 1))
      this.current = 0

    this.setItem(this.current)

  }

  setItem(index) {

    this.items.removeClass('matchBox__infoItem--active')
    this.items[index].addClass('matchBox__infoItem--active')

  }

  pollVote(index) {

    var event_id = $("#event_id").val();
    var that = this;

    $.getJSON("/matchVote?event_id="+event_id+"&vote="+index, function(data) {

        for (var i = 0; i < data.length; i++) {
            that.percents[i].innerHTML = "" + data[i] + '%'
        }
        that.percents.addClass('matchBox__teamPercent--active')
    });

  }

}
